import { render, staticRenderFns } from "./SimulationParams.vue?vue&type=template&id=47fb1a50&scoped=true"
import script from "./SimulationParams.vue?vue&type=script&lang=js"
export * from "./SimulationParams.vue?vue&type=script&lang=js"
import style0 from "./SimulationParams.vue?vue&type=style&index=0&id=47fb1a50&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb1a50",
  null
  
)

export default component.exports